export default "__VITE_ASSET__BRTdm_VM__"